import './polyfills';
import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';

// Disable the browser's automatic scroll restoration so a refresh always
// lands the visitor at the top of the page rather than wherever they were
// last scrolled. Per-route scroll resets are handled inside each page.
if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// react-snap pre-renders each route to static HTML at build time. When that
// HTML is present, hydrate it; otherwise (dev server) render from scratch.
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}
